import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Credentials } from '@/store/auth/types';
import { onMounted, ref } from 'vue';
// eslint-disable-next-line vue/no-setup-props-destructure

export default /*@__PURE__*/_defineComponent({
  __name: 'CredentialsSniffer',
  props: {
    adminUrls: {},
    timeoutMs: {}
  },
  emits: ["credentialsFound", "noCredentialsFound"],
  setup(__props: any, { emit: __emit }) {



const emit =
  __emit;

const iframeWrapper = ref<HTMLIFrameElement | null>(null);

const isCredentials = (maybeCreds: any): maybeCreds is Credentials =>
  !!maybeCreds && !!maybeCreds['access-token'] && maybeCreds.client && maybeCreds.uid;

const checkAdminUrl = (adminUrl: string): Promise<Credentials | 'none'> => {
  const iframe = document.createElement('iframe');
  iframe.src = `${adminUrl}/auth/browser-extension-provider`;
  iframe.className = 'credentials-iframe';

  const credentialsPromise = new Promise<Credentials | 'none'>((resolve) => {
    const listener = (messageEvent: MessageEvent<any>): void => {
      if (messageEvent.origin !== adminUrl) {
        return;
      }

      removeEventListener('message', listener);
      iframe.remove();
      resolve(isCredentials(messageEvent.data) ? messageEvent.data : 'none');
    };

    addEventListener('message', listener);
    setTimeout(() => {
      removeEventListener('message', listener);
      iframe.remove();
      resolve('none');
    }, __props.timeoutMs);
    iframeWrapper.value?.appendChild(iframe);
  });

  return credentialsPromise;
};

onMounted(async () => {
  for (const adminUrl of __props.adminUrls) {
    const credsOrNone = await checkAdminUrl(adminUrl);

    if (credsOrNone !== 'none') {
      emit('credentialsFound', credsOrNone);
      return;
    }
  }

  emit('noCredentialsFound');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "iframeWrapper",
    ref: iframeWrapper,
    class: "credentials-iframe-wrapper"
  }, null, 512))
}
}

})